import './Tag.less'
import Tag from './Tag'
export default Tag
